module.exports = __webpack_public_path__ + "static/media/map.f77506f2.png";